// frontend/src/features/workflows/utils/runFormatting.js

import {
  getRunParamsFromProvenance,
} from './derivedRunDraft';

export function formatRunTimestamp(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return String(value);
  }
}

export function getRunValidity(run) {
  if (run?.is_valid === true) return 'Valid';
  if (run?.is_valid === false) return 'Invalid';
  return '—';
}

export function formatRunParams(run) {
  const params = getRunParamsFromProvenance(run) || {};

  if (run?.pipeline === 'encapsulation') {
    const prominence = params?.prominence;
    const width = params?.width_factor;
    const parts = [];
    if (prominence != null) parts.push(`prominence ${prominence}`);
    if (width != null) parts.push(`width ${width}`);
    return parts.length ? parts.join(', ') : '—';
  }

  if (run?.pipeline === 'size') {
    const detection = params?.detection ?? params;
    if (!detection || typeof detection !== 'object') return '—';
    const keys = ['prominence', 'area_threshold', 'min_width_seconds', 'min_distance_seconds'];
    const parts = keys
      .map((key) => {
        const value = detection[key];
        return value != null ? `${key}=${value}` : null;
      })
      .filter(Boolean);
    return parts.length ? `detection: ${parts.join(', ')}` : '—';
  }

  return '—';
}

export function formatRunChangeSummary(run) {
  return `Params ${run?.params_changed ? 'changed' : 'same'} • Trace ${
    run?.trace_changed ? 'changed' : 'same'
  }`;
}
